/* eslint-disable prettier/prettier */
// IMPORTANT: THIS FILE IS AUTO GENERATED! DO NOT MANUALLY EDIT OR CHECKIN!
export const VERSION = {
  "gitBuildGlobalVersion": "2.6.1",
  "gitBuildTime": "2026-03-04T20:19:46.902Z",
  "gitBuildVersion": "2.6.1",
  "gitCommitId": "f79290a",
  "gitCommitIdFull": "f79290aa4df4a7deafc12dc356cdc0765ed63566",
  "gitCommitTime": "2026-03-04T20:17:32.000Z",
  "version": "2.6.1-2026-03-04T20:17:32.000Z-(f79290a)"
};
